export default "__VITE_ASSET__36c192a2__"